var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import CustomScrollbars from '../../CustomScrollbar';
import * as ST from './styled';
var BasePopup = function (_a) {
    var children = _a.children, title = _a.title, description = _a.description, customBasePopupStyles = _a.customBasePopupStyles, customDefaultPopupStyles = _a.customDefaultPopupStyles, customScrollBarStyles = _a.customScrollBarStyles, props = __rest(_a, ["children", "title", "description", "customBasePopupStyles", "customDefaultPopupStyles", "customScrollBarStyles"]);
    var descIsString = typeof description === 'string';
    return (<ST.SDefaultPopup customStyles={customDefaultPopupStyles} {...props}>
            <ST.TopWrapper customStyles={customBasePopupStyles}>
                <ST.Title>{title}</ST.Title>
                {description
            ? descIsString
                ? <ST.Text>{description}</ST.Text>
                : description
            : null}
            </ST.TopWrapper>
            <ST.ContentWrapper customStyles={customBasePopupStyles}>
                <CustomScrollbars customStyles={customScrollBarStyles}>
                    <ST.ContentInner customStyles={customBasePopupStyles}>
                        {children}
                    </ST.ContentInner>
                </CustomScrollbars>
            </ST.ContentWrapper>
        </ST.SDefaultPopup>);
};
export default BasePopup;
